import axios from 'axios'
import { getClientById } from '@/composables/useClientService'

type ClientFilter = {
  query?: string
  repId?: number
  rayonId?: number
  clientType2Id?: number
  productId?: number
  tierId?: number
  labelId?: number
  targeted?: boolean
  optIn?: boolean
  visited?: boolean
  isActive?: boolean
  properties?: object
  orderByColumn?: string
  orderByDirection?: string
}

export type ClientPage = ClientFilter & {
  limit?: number
  offset?: number
  brickIds?: number[]
  clientTypeIds?: number[]
  onlyWithEmail?: boolean
  visitedFrom?: string
  visitedTo?: string
  visitedPeriod?: 'cycle' | 'range'
  visitedTypeId?: number
}

export type ClientExportFilter = ClientFilter & {
  brickId?: number
  clientTypeId?: number
}

export default class ClientService {
  public getAll(page: ClientPage) {
    return axios.get('/api/v1/clients', {
      params: { query: '', limit: 50, offset: 0, ...page },
    })
  }

  public getAllExcel(filter: ClientExportFilter) {
    return axios.get('/api/v1/clients/export', {
      responseType: 'blob',
      params: { query: '', ...filter },
    })
  }

  public getById(id) {
    return getClientById(id)
  }

  public getSummaryDispensedMaterial(id: number) {
    return axios.get(`/api/v1/client/${id}/summary-dispensed-material`)
  }

  public getSummaryCurrentCycle(id: number) {
    return axios.get(`/api/v1/clients/${id}/summary-current-cycle`)
  }

  public getRecentInteractions(clientId: number, offset?: number) {
    return axios.get(`/api/v1/clients/${clientId}/recent-interactions`, {
      params: {
        offset,
      },
    })
  }

  public getPlannedInteractions(clientId: number, offset?: number) {
    return axios.get(`/api/v1/clients/${clientId}/planned-interactions`, {
      params: {
        offset,
      },
    })
  }

  public addEmail(id: number, email: string, isSecondary: boolean = false) {
    return axios.post('/api/v1/clients/' + id + '/add-email', {
      email,
      isSecondary,
    })
  }

  public consentWithoutSignature(id: number) {
    return axios.post(`/api/v1/clients/${id}/consent-without-signature`)
  }

  public consent(
    id: number,
    signatureDataUri: string,
    consentCheckbox: boolean = false,
  ) {
    return axios.post(`/api/v1/clients/${id}/consent`, {
      signatureDataUri,
      consentCheckbox,
    })
  }

  public changeNote(id: number, note: string) {
    return axios.post(`/api/v1/clients/${id}/note`, {
      note,
    })
  }

  public withdrawConsent(id: number) {
    return axios.delete('/api/v1/clients/' + id + '/consent')
  }

  public delete(id: number) {
    return axios.delete(`/api/v1/clients/${id}`)
  }
}
